module.exports = __webpack_public_path__ + "static/media/click-to-join.ad3f6e28.gif";